import React, { createContext, useEffect, useState } from 'react'
import FirstCornStep from './FirstCornStep';
import SecondCornStep from './SecondCornStep';
import ThirdCornStep from './ThirdCornStep';
import { StyledButtonGroup, StyledButtonOr, StyledTabButton, TabContainer, TabContent } from '../GrassSilageStep/style';
import { CO2OptionsType } from '~/api/services/co2';
import { useFormContext, useWatch } from 'react-hook-form';

export const ClimaOptionsContext = createContext<CO2OptionsType>(null)
interface Props {
  options: CO2OptionsType
}

const CornSilageStep: React.FC<Props> = ({ options }) => {
  const { control } = useFormContext()
  const cornSilageStep = useWatch({ control, name: 'maizeSilage.step' })

  const [activeCornStep, setActiveCornStep] = useState(cornSilageStep || 0)
  const [isTransitioning, setIsTransitioning] = useState(false)

  function renderSteps() {
    switch (activeCornStep) {
      case 0:
        return <FirstCornStep />
      case 1:
        return <SecondCornStep />
      case 2:
        return <ThirdCornStep />
      default:
        return <FirstCornStep />
    }
  }

  useEffect(() => {
    handleTabChange(cornSilageStep || 0)
  }, [cornSilageStep])

  const handleTabChange = async (newStep: number) => {
    if (newStep === activeCornStep) return

    setIsTransitioning(true)

    await new Promise(resolve => setTimeout(resolve, 200))

    setActiveCornStep(newStep)

    setTimeout(() => setIsTransitioning(false), 200)
  }

  return (
    <ClimaOptionsContext.Provider value={{ ...options }}>
      <TabContainer>
        <StyledButtonGroup widths={'3'} size={'large'}>
          <StyledTabButton
            className={activeCornStep === 0 ? 'active-step' : ''}
            type={'button'}
            content={'Ernte und Ertrag'}
            disabled={isTransitioning}
          />
          <StyledButtonOr text='>>' />
          <StyledTabButton
            className={activeCornStep === 1 ? 'active-step' : ''}
            type={'button'}
            content={'Düngung'}
            disabled={isTransitioning}
          />
          <StyledButtonOr text='>>' />
          <StyledTabButton
            className={activeCornStep === 2 ? 'active-step' : ''}
            type={'button'}
            content={'Bewirtschaftung'}
            disabled={isTransitioning}
          />
        </StyledButtonGroup>

        <TabContent
          isTransitioning={isTransitioning}
          activeStep={activeCornStep}
        >
          {!isTransitioning && renderSteps()}
        </TabContent>
      </TabContainer>
    </ClimaOptionsContext.Provider>
  )
}

export default CornSilageStep